var _Mask, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
function SvgCheckboxEmpty(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "gray",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Mask || (_Mask = /*#__PURE__*/React.createElement(Mask, {
    id: "checkbox-empty_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm14 16V5H5v14h14z",
    fill: "#fff"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#checkbox-empty_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillOpacity: 0.6,
    d: "M0 0h24v24H0z"
  }))));
}
export default SvgCheckboxEmpty;